<template>
  <div>
    <div class="landing-page">
      <img
        :src="
          `https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${templateId}/${compId}/lp/${
            screenWidth > 576 ? '' : 'm-'
          }landing-page-bg.webp`
        "
        alt=""
      />
      <div
        v-if="false"
        :class="screenWidth <= 576 ? 'isMobile' : ''"
        class="landing-page-video"
      >
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/e_dsVkV5DKw?autoplay=1&mute=1"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <a
        v-for="num in 6"
        :key="num"
        :class="[
          `landing-page-link-${num}`,
          screenWidth <= 576 ? 'isMobile' : ''
        ]"
        class="landing-page-link"
        href="#"
        @click.prevent="showAuthModal('signUp')"
      >
      </a>
    </div>
    <no-ssr>
      <AuthModal
        ref="authModal"
        :layout="'A'"
        :menu="'tabs'"
        :has-img="true"
        :img-pc-src="(authBanner || {}).imgPath"
        :img-mobile-src="(authBanner || {}).mobileImgPath"
        :step="true"
        :has-sign-up-actual-name="true"
        :has-sign-up-confirm-password="true"
        :has-forget-pwd-tel-form="false"
        :has-email-verify-code="compCommon.signUp.emailVerifyCode.enable"
        :intel-countries="[defaultCountry]"
        :custom-username-rule="customUsernameRule"
        :close-default-src="
          'https://ik.imagekit.io/1pzxddx3qqv/mc/img/popup_close_btn_default.png'
        "
        :close-hover-src="
          'https://ik.imagekit.io/1pzxddx3qqv/mc/img/popup_close_btn_hover.png'
        "
        @loginSuccessAfter="loginSuccessAfter"
        @signUpSuccessAfter="signUpStepSuccessAfter('/user/inbox')"
      >
      </AuthModal>
    </no-ssr>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  ref,
  useMeta,
  useRoute,
  useStore
} from '@nuxtjs/composition-api'
import { mergeObjArrByKey } from 'fe-common'
import AuthModal from '../../../components/AuthModal'
import useHead from '../../../composables/useHead'
import useComp from '../../../composables/useComp'
import useErrorHandler from '../../../composables/useErrorHandler'
import useAuthModal from '../../../composables/useAuthModal'

export default defineComponent({
  layout: 'nothing',
  components: {
    AuthModal
  },
  // middleware({ redirect }) {
  //   return redirect('/')
  // },
  head: {},
  setup(props, context) {
    const { genHead } = useHead()
    const head = genHead()
    const meta = [
      {
        hid: 'twitter:card',
        name: 'twitter:card',
        content: ''
      },
      {
        hid: 'twitter:title',
        name: 'twitter:title',
        content: ''
      },
      {
        hid: 'twitter:image',
        name: 'twitter:image',
        content: ''
      },
      {
        hid: 'twitter:image:src',
        name: 'twitter:image:src',
        content: ''
      },
      {
        hid: 'twitter:site',
        name: 'twitter:site',
        content: '@wonder_casino'
      },
      {
        hid: 'twitter:creator',
        name: 'twitter:creator',
        content: '@wonder_casino'
      },
      {
        hid: 'twitter:description',
        name: 'twitter:description',
        content: ''
      }
    ]
    meta.push({ hid: 'robots', name: 'robots', content: 'noindex' })

    useMeta(() => {
      const { title } = genHead()
      return {
        ...head,
        title,
        meta: mergeObjArrByKey(head.meta, meta, 'hid')
      }
    })

    const store = useStore()
    const route = useRoute()

    const customUsernameRule = {
      required: true,
      regex: new RegExp(/^([A-Za-z][0-9A-Za-z]*)$/),
      min: 6,
      max: 15
    }

    const defaultCountry = computed(() => process.env.DEFAULT_COUNTRY)
    const templateId = computed(() => process.env.TEMPLATE_ID)
    const isMobile = computed(() => store.state.isMobile)
    const authBanners = computed(() => store.state.bannerModule.authBanners)
    const authBanner = computed(() => authBanners.value[0] || null)

    const { compId, compCommon } = useComp()
    const { errorHandler } = useErrorHandler(context)
    const { loginSuccessAfter, signUpStepSuccessAfter } = useAuthModal(context)

    const authModal = ref(null)

    const screenWidth = ref(0)

    onMounted(() => {
      screenWidth.value = window.innerWidth

      window.onresize = () => {
        return (() => {
          screenWidth.value = window.innerWidth
        })()
      }
    })

    function showAuthModal(category) {
      getAuthBanner()
      nextTick(() => {
        if (authModal.value) {
          authModal.value.show(category)
        }
      })
    }

    function getAuthBanner() {
      store
        .dispatch('getAuthBanners', {
          tag: (route.value.query.source === 'lp' ? 'LP' : '') + 'SIGN'
        })
        .catch(err => errorHandler(err))
    }

    return {
      templateId,
      isMobile,
      compId,
      screenWidth,
      customUsernameRule,
      defaultCountry,
      authBanner,
      authModal,
      compCommon,

      showAuthModal,
      loginSuccessAfter,
      signUpStepSuccessAfter
    }
  }
})
</script>
